import * as React from 'react';

import { enumDocumentType } from '@rematter/frontend-lib-api-client';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { PurchaseLoadRecord } from '~/modules/trade/types/purchaseLoad';
import { PrintableDocument } from '~/modules/trade/types/scaleTickets';

export const useInboundPrintDocuments = (
  ticket: PurchaseLoadRecord | null,
): PrintableDocument[] => {
  const t = useTranslations();

  return React.useMemo(
    () =>
      ticket
        ? [
            {
              label: t.scaleTicketPro.documents.types.purchaseOrder,
              documentType: enumDocumentType.PurchaseOrder,
              loadId: ticket.id,
              purchaseOrderId: ticket.purchaseOrderId ?? undefined,
              isDisabled: !ticket.purchaseOrderId,
              toastMessage: t.transactionsView.actions.printingPurchaseOrder,
            },
            {
              label: t.scaleTicketPro.documents.types.thermalWeightTicket,
              documentType: enumDocumentType.ThermalWeightTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingThermalWeightTicket,
            },
            {
              label: t.scaleTicketPro.documents.types.fullPageWeightTicket,
              documentType: enumDocumentType.FullPageWeightTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingFullPageWeightTicket,
            },
            {
              label: t.scaleTicketPro.documents.types.thermalScaleTicket,
              documentType: enumDocumentType.ThermalScaleTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingThermalScaleTicket,
            },
            {
              label: t.scaleTicketPro.documents.types.fullPageScaleTicket,
              documentType: enumDocumentType.FullPageScaleTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingFullPageScaleTicket,
            },
          ]
        : [],
    [ticket?.id, ticket?.purchaseOrderId, t],
  );
};
